import store from '../../../store/sellsyaccountmanager/pricing';

export default {
    created() {
        // Init store
        this.$store.registerModule('pricing', store);
    },
}